import { UserReference } from "@legacy-megarax/common";
import { idObjectReferenceSerializer } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";
import Decimal from "decimal.js";

import {
  currencies,
  Currency,
  CustomerReference,
  customerReferenceSerializer,
  Gtin,
  gtinSerializer,
  PriceListReference,
  priceListReferenceSerializer,
} from "../common";
import { OrderDraftStatus } from "./draftStatus";

export type OrderDraftLineDto = {
  uuid: string;
  quantity: number;
  promoPrice: Decimal | null;
  basePrice: Decimal;
  finalPrice: Decimal;
  lineNetTotal: Decimal;
  item: {
    gtin: Gtin;
  };
};

export type OrderDraftDto<TStatus extends OrderDraftStatus = OrderDraftStatus> = {
  uuid: string;
  owner: UserReference;

  lines: OrderDraftLineDto[];

  payer: CustomerReference;
  buyer: CustomerReference;
  recipient: CustomerReference;

  payerDiscountRate: Decimal;
  priceList: PriceListReference;

  isFinalized: boolean;
  isDiscarded: boolean;

  netTotal: Decimal;
  currency: Currency;

  startedAt: Date;

  finalizedAt: TStatus extends "finalized" ? Date : null;
  discardedAt: TStatus extends "finalized" ? Date : null;
};

const orderDraftLineDtoSerializer = MSerializers.object<OrderDraftLineDto>({
  uuid: MSerializers.uuid(),
  item: MSerializers.object({ gtin: gtinSerializer }),
  promoPrice: MSerializers.decimal.nullable(),
  quantity: MSerializers.integer,
  lineNetTotal: MSerializers.decimal,
  finalPrice: MSerializers.decimal,
  basePrice: MSerializers.decimal,
});
export const orderDraftDtoSerializer = MSerializers.object<OrderDraftDto>({
  uuid: MSerializers.uuid(),
  payerDiscountRate: MSerializers.decimal,
  buyer: customerReferenceSerializer,
  payer: customerReferenceSerializer,
  recipient: customerReferenceSerializer,
  isFinalized: MSerializers.boolean,
  finalizedAt: MSerializers.datetime.nullable(),
  priceList: priceListReferenceSerializer,
  lines: MSerializers.array(orderDraftLineDtoSerializer),
  owner: idObjectReferenceSerializer,
  isDiscarded: MSerializers.boolean,
  startedAt: MSerializers.datetime,
  discardedAt: MSerializers.datetime.nullable(),
  netTotal: MSerializers.decimal,
  currency: MSerializers.stringOneOf(...currencies),
});
